import { useTranslation } from "react-i18next";

import { Stack, Typography } from "@mui/material";
import { FormikProps } from "formik";

import { AssetRelativesFormValues } from "../../RelativesView.types";
import { DependantCard } from "../dependant-card/DependantCard";

interface Props {
  formik: FormikProps<AssetRelativesFormValues>;
  livesInHousehold: boolean;
  onRemove: (index: number) => void;
}

export function DependantsBlock({ formik, livesInHousehold, onRemove }: Props) {
  const { t } = useTranslation();
  const section = "clients.client.debtSettlement.assetInventory.dependants";

  const entries = formik.values.dependants
    .map((dependant, index) => ({ dependant, index }))
    .filter((entry) => entry.dependant.livesInHousehold === livesInHousehold);

  return (
    <Stack gap={2}>
      <Typography variant="h6">
        {livesInHousehold ? t(`${section}.householdTitle`) : t(`${section}.nonHouseholdTitle`)}
      </Typography>

      {entries.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {livesInHousehold ? t(`${section}.householdEmpty`) : t(`${section}.nonHouseholdEmpty`)}
        </Typography>
      ) : (
        entries.map((entry) => (
          <DependantCard
            key={entry.dependant.key}
            formik={formik}
            index={entry.index}
            onRemove={() => onRemove(entry.index)}
          />
        ))
      )}
    </Stack>
  );
}
